import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Box,
  Grid,
  Container,
  Card,
  CardActionArea,
  CardContent,
  Paper,
  useTheme,
  IconButton
} from '@mui/material';
import * as Icons from '@mui/icons-material';

function Telegram() {
  const navigate = useNavigate();
  const theme = useTheme();

  const buttonData = [
    {
      icon: <Icons.Group sx={{ fontSize: 48 }} />,
      label: 'Utenti Telegram',
      description: 'Gestisci gli utenti del bot',
      color: theme.palette.primary.main,
      onClick: () => navigate('/telegram/users')
    },
    {
      icon: <Icons.Translate sx={{ fontSize: 48 }} />,
      label: 'Traduzioni',
      description: 'Gestisci le traduzioni del bot',
      color: theme.palette.primary.main,
      onClick: () => navigate('/telegram/translations')
    },
    {
      icon: <Icons.Message sx={{ fontSize: 48 }} />,
      label: 'Messaggi',
      description: 'Visualizza i messaggi inviati e ricevuti',
      color: theme.palette.primary.main,
      onClick: () => navigate('/telegram/messages')
    },
  ];

  return (
    <Box sx={{
      minHeight: '100vh',
      py: 6
    }}>
      <Container maxWidth="lg">
        <Paper elevation={0} sx={{
          p: 2,
          mb: 4,
          background: 'transparent',
          display: 'flex',
          alignItems: 'center'
        }}>
          <IconButton onClick={() => navigate('/')} sx={{ color: 'white', mr: 2 }}>
            <Icons.ArrowBack />
          </IconButton>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'white', m: 0 }}>
            Telegram HUB
          </Typography>
        </Paper>

        <Grid container spacing={3} justifyContent="center">
          {buttonData.map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card sx={{
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',
                  boxShadow: `0 12px 24px rgba(0,0,0,0.4), 0 0 20px ${item.color} 22`,
                  borderColor: item.color,
                }
              }}>
                <CardActionArea onClick={item.onClick} sx={{ height: '100%', p: 2 }}>
                  <CardContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}>
                    <Box sx={{
                      mb: 2,
                      color: item.color,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      p: 2,
                      borderRadius: '50%',
                      backgroundColor: `${item.color}11`
                    }}>
                      {item.icon}
                    </Box>
                    <Typography variant="h5" component="h2" sx={{ mb: 1, fontWeight: 600, color: 'white' }}>
                      {item.label}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Telegram;
